export default {
  update: 'Обновить',
  edit: 'Редактировать',
  export_xls: 'Загрузить',
  export_rda: 'Экспортировать в RD Cloud',
  duplicate: 'Дублировать',
  add_element: 'Добавить элемент',
  add_dashboard_element: 'Добавить dashboard элемент',
  add_to_dashboard: 'Добавить на dashboard',
  configuredElements: 'Настроенные элементы',
  set_background: 'Изменить фон',
  acknowledgeTheEvent: 'Подтвердить событие',
  delete: 'Удалить',
  background_color: 'Цвет фона',
  background_image: 'Изображение фона',
  comment: 'Коментарий'
}
